export var BadgeSize;
(function (BadgeSize) {
    BadgeSize["Small"] = "small";
    BadgeSize["Big"] = "big";
    BadgeSize["Auto"] = "auto";
})(BadgeSize || (BadgeSize = {}));
export var BadgeColor;
(function (BadgeColor) {
    BadgeColor["Brand"] = "brand";
    BadgeColor["Complementary"] = "complementary";
    BadgeColor["Green"] = "green";
})(BadgeColor || (BadgeColor = {}));
